/**
 * 动态路由
 */
export default [
  {
    path: '/space',
    redirect: '/space/index',
    meta: {
      sort: 2,
      roles: ['ordinaryUser', 'supperAdmin', 'analyseAdmin']
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/space/index',
        meta: {
          title: '企业空间',
          icon: 'space',
          level: 1
        },
        component: () => import('@/views/space/index.vue')
      }
    ]
  },
  {
    path: '/external-space',
    redirect: '/external-space/index',
    meta: {
      sort: 2,
      roles: ['externalUser', 'supperAdmin']
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/external-space/index',
        meta: {
          title: '外部空间',
          icon: 'space',
          level: 1
        },
        component: () => import('@/views/external/index.vue')
      }
    ]
  },
  {
    path: '/recycle',
    redirect: '/recycle/index',
    meta: {
      sort: 4,
      roles: ['ordinaryUser', 'supperAdmin', 'analyseAdmin']
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/recycle/index',
        meta: {
          title: '回收站',
          icon: 'recycle',
          level: 1
        },
        component: () => import('@/views/recycle/index.vue')
      }
    ]
  },
  {
    path: '/statastic',
    redirect: '/statastic/uploadData',
    meta: {
      title: '统计分析',
      sort: 4,
      icon: 'statistic',
      level: 1,
      roles: 'analyseAdmin'
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/statastic/uploadData',
        meta: {
          title: '上传数据分析',
          level: 2
        },
        component: () => import('@/views/uploadData/index.vue')
      },
      {
        path: '/statastic/useData',
        meta: {
          title: '使用情况数据',
          level: 2
        },
        component: () => import('@/views/useData/index.vue')
      }
    ]
  },
  {
    path: '/operationLog',
    redirect: '/operationLog/index',
    meta: {
      sort: 5,
      roles: 'analyseAdmin'
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/operationLog/index',
        meta: {
          title: '操作日志',
          icon: 'document',
          level: 1
        },
        component: () => import('@/views/operationLog/index.vue')
      }
    ]
  },
  {
    path: '/authManage',
    redirect: '/authManage/index',
    meta: {
      sort: 5,
      roles: 'supperAdmin'
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/authManage/index',
        meta: {
          title: '权限管理',
          icon: 'authManage',
          level: 1
        },
        component: () => import('@/views/authManage/index.vue')
      }
    ]
  },
  {
    path: '/tagManage',
    redirect: '/tagManage/index',
    meta: {
      sort: 6,
      roles: 'supperAdmin'
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/tagManage/index',
        meta: {
          title: '标签管理',
          icon: 'tag2',
          level: 1
        },
        component: () => import('@/views/tag/index.vue')
      }
    ]
  },
  {
    path: '/shareManage',
    redirect: '/shareManage/linkManage',
    meta: {
      title: '分享管理',
      sort: 7,
      icon: 'share',
      level: 1,
      roles: 'supperAdmin'
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/shareManage/linkManage',
        meta: {
          title: '分享链接管理',
          level: 2
        },
        component: () => import('@/views/linkManage/index.vue')
      },
      {
        path: '/shareManage/visitorManage',
        meta: {
          title: '访问人列表',
          level: 2
        },
        component: () => import('@/views/linkVisitorManage/index.vue')
      }
    ]
  },
  {
    path: '/externalUser',
    redirect: '/externalUser/userManage',
    meta: {
      title: '外部人员',
      sort: 8,
      icon: 'authManage',
      level: 1,
      roles: ['supperAdmin', 'externalAdmin']
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/externalUser/userManage',
        meta: {
          title: '外部人员管理',
          level: 2
        },
        component: () => import('@/views/external-user/index.vue')
      },
      {
        path: '/externalUser/authManage',
        meta: {
          title: '外部人员权限配置',
          level: 2
        },
        component: () => import('@/views/external-user/auth.vue')
      }
    ]
  }
];
